import React from 'react'
import '../assets/css/AdHocMultipleAddsModal.css';
import Button from '../DMGComponents/Button'
import EmailAddressesTextArea from './EmailAddressesTextArea'
import { checkUserExistance } from '../fetchData';
import toast from 'react-hot-toast';
import Spinner from './Spinner';

class AddMultipleUsers extends React.Component {
    constructor(props) {
        super(props);
        this._emailTextArea = React.createRef();
        this.state = {
            notFoundErrorMsg: '',
            checking: false,
            validUsers: [],
            hasInvalidEmails: false,
            validEmails: [],
        }
    }

    checkUsers = () => {
        let usersToSearchFor = []
        this.state.validEmails.forEach(email => {
            let checkIfAlreadyInArea = this.props.currentUsers.find(u => u.email === email);
            if (checkIfAlreadyInArea === undefined) {
                usersToSearchFor.push({ email: email })
            }
        });
        this.setState({
            notFoundErrorMsg: '',
            checking: true,
            validUsers: [],
        });
        checkUserExistance(this.props.areaId, usersToSearchFor).then((res) => {
            let valMsg = "No user found for following emails (these will be ignored and must be added via 'Create New User'): ";
            let notExistingUserFound = false;
            let foundUsers = [];
            usersToSearchFor.forEach(usr => {
                let foundUser = res.find(fUser => fUser.email.toUpperCase() === usr.email.toUpperCase());
                if (foundUser !== undefined) {
                    foundUsers.push(foundUser);
                }
                else {
                    notExistingUserFound = true;
                    valMsg += usr.email + ", "; 
                }
            });
            if (notExistingUserFound) {
                valMsg = valMsg.slice(0, -2);
            }
            else {
                valMsg = '';
            }
            this.setState({
                notFoundErrorMsg: valMsg,
                checking: false,
                validUsers: foundUsers,
            });
        }).catch((err) => {
            toast.error("There was an error checking users");
            console.error("Error", err);
            this.setState({
                notFoundErrorMsg: '',
                checking: false,
                validUsers: [],
            });
        })
    }

    addUsers = () => {
        this.handleClose();
        if (typeof this.props.addMultipleUsers === 'function') {
            this.props.addMultipleUsers(this.state.validUsers);
        }
    }

    handleClose = () => {
        this.setState({
            validEmails: [],
            notFoundErrorMsg: '',
            checking: false,
            validUsers: [],
        }, () => {
            this._emailTextArea.current.handleClose();
            if (typeof this.props.handleClose === 'function') {
                this.props.handleClose();
            }
        });
    }

    updateValidEmails = (validEmails) => {
        this.setState({
            validEmails: validEmails
        });
    }

    updateInvalidEmails = (hasInvalidEmails) => {
        this.setState({
            hasInvalidEmails: hasInvalidEmails
        });
    }

    render() {
        const showHideClassName = this.props.show ? "ahModal display-block" : "ahModal display-none";
        return (
            <div className={showHideClassName}>
                <section className="ahModal-main">
                    <div className="ahModal-buttons">
                        {this.state.checking &&
                            <span style={{ marginRight: "120px" }}>
                                <Spinner />
                            </span>
                        }
                        {!this.state.checking &&
                            <React.Fragment>
                                <span style={{ marginRight: "12px" }}>
                                    <Button type="hover-bottom-left" onClick={() => { this.addUsers() }} disabled={!(this.state.validUsers.length > 0 && !this.state.hasInvalidEmails && !this.state.checking)} >Add users</Button>
                                </span>
                                <span style={{ marginRight: "12px" }}>
                                    <Button type="hover-bottom-left" onClick={() => { this.checkUsers() }} disabled={!(this.state.validEmails.length > 0 && !this.state.hasInvalidEmails && !this.state.checking)} >Check users</Button>
                                </span>
                            </React.Fragment>
                        }
                        <Button type="hover-bottom-left" onClick={() => { this.handleClose() }}>Close</Button>
                    </div>  
                    <div className="ahModal-emails">
                        <label>Emails must be checked if they exist in the system. Only already created users can be added.</label>
                        {this.state.notFoundErrorMsg.length > 0 &&
                            <label style={{ color: "#F50506" }}>{this.state.notFoundErrorMsg}</label>
                        }
                        <EmailAddressesTextArea updateValidEmails={this.updateValidEmails} updateInvalidEmails={this.updateInvalidEmails} ref={this._emailTextArea} />
                    </div>
                </section>
            </div>
        );
    }
};

export default AddMultipleUsers;